import {Model} from '@vuex-orm/core';
import Dua from './Dua';

export default class DuaCategory extends Model {
    static entity = 'dua_categories';

    static fields () {
        return {
            id: this.number(0),
            name: this.string(''),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            duas: this.hasMany(Dua, 'duacategory_id'),
        };
    }
}
